import { ROUTES } from '../../routes/consts';
import { StepConfig } from '../../shared/MultiStepDialog';
import { spawn } from '../../utils/translations';
import { FORM_IDS, STEPS_TRANSLATION_KEY, STEP_IDS } from './consts';

const spawnSteps = spawn(STEPS_TRANSLATION_KEY);

/**
 * The 3-step wizard: an informational prerequisites step (create the Qodo
 * user + grant permissions — no inputs, a plain Continue), the
 * credentials form, then the auto-import. The import step has no Back button and
 * its primary button is always "Done" — disabled until the import completes,
 * then a plain submit that finishes the wizard. Cancel stays available while the
 * import runs (the escape hatch) and is hidden once it completes.
 */
export const getSteps = ({
  isFinalized,
}: {
  isFinalized: boolean;
}): StepConfig[] => [
  {
    id: STEP_IDS.PREREQUISITES,
    path: ROUTES.GERRIT_INSTALLATION_STEP_1,
    title: spawnSteps('prerequisites.title'),
    shouldShowBackButton: false,
    shouldShowCancelButton: true,
    isNextInitiallyEnabled: true,
    nextLabel: spawnSteps('prerequisites.next-label'),
  },
  {
    id: STEP_IDS.CONNECT,
    path: ROUTES.GERRIT_INSTALLATION_STEP_2,
    title: spawnSteps('connect.title'),
    shouldShowBackButton: false,
    shouldShowCancelButton: true,
    isNextInitiallyEnabled: true,
    nextLabel: spawnSteps('connect.next-label'),
    formId: FORM_IDS.CONNECT,
  },
  {
    id: STEP_IDS.IMPORT_PROGRESS,
    path: ROUTES.GERRIT_INSTALLATION_STEP_3,
    title: spawnSteps('import.title'),
    shouldShowBackButton: false,
    shouldShowCancelButton: !isFinalized,
    isNextInitiallyEnabled: false,
    nextLabel: spawnSteps('import.done-label'),
    formId: FORM_IDS.IMPORT_PROGRESS,
  },
];
